export type DeploymentVersion = 'v2' | 'v3' | 'v4'

export type ContractAddresses = {
  factoryAddress?: string
  infoAddress?: string
  multicallAddress?: string
  hotKeyAddress?: string
  WETHAddress?: string
  routerAddress?: Record<string, string>
  contractAddress?: string
  defaultAddress?: string
}

export type ContractDeployment = {
  id: string
  chainId: number
  version: DeploymentVersion
  description: string
  canCreate: boolean
  addresses: ContractAddresses
}

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const contractRegistry: ContractDeployment[] = [
  {
    id: 'eth-v4-current',
    chainId: 1,
    version: 'v4',
    description: 'Ethereum (current)',
    canCreate: true,
    addresses: {
      factoryAddress: '0x9A6303f55FD013d58898994D563Cb0Bf60F4eC82',
      multicallAddress: '0xB8bAA4dE87feD17e45206eB7DB6619bb198222Ff',
      infoAddress: '0xfd6a2937355D7ab36BfC318894223853A1f6807D',
      hotKeyAddress: '0x018DD3A0Dd7F213cc822076b3800816d3CE1ED86',
      contractAddress: ZERO_ADDRESS,
      WETHAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      routerAddress: {
        'uniswap': '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D'
      },
      defaultAddress: ZERO_ADDRESS
    }
  },
  {
    id: 'bsc-v4-current',
    chainId: 56,
    version: 'v4',
    description: 'BSC (current)',
    canCreate: false,
    addresses: {
      factoryAddress: '0x9A6303f55FD013d58898994D563Cb0Bf60F4eC82',
      multicallAddress: '0xB8bAA4dE87feD17e45206eB7DB6619bb198222Ff',
      infoAddress: '0xfd6a2937355D7ab36BfC318894223853A1f6807D',
      hotKeyAddress: '0x374Ad0440Cd5c8E1A8412C156BeeEcE108EF4bB6',
      contractAddress: ZERO_ADDRESS,
      WETHAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      routerAddress: {
        'uniswap': '0x10ED43C718714eb63d5aA57B78B54704E256024E'
      },
      defaultAddress: ZERO_ADDRESS
    }
  },
  {
    id: 'base-v4-current',
    chainId: 8453,
    version: 'v4',
    description: 'Base (current)',
    canCreate: false,
    addresses: {
      factoryAddress: '0x9A6303f55FD013d58898994D563Cb0Bf60F4eC82',
      multicallAddress: '0xB8bAA4dE87feD17e45206eB7DB6619bb198222Ff',
      infoAddress: '0xfd6a2937355D7ab36BfC318894223853A1f6807D',
      hotKeyAddress: '0x374Ad0440Cd5c8E1A8412C156BeeEcE108EF4bB6',
      contractAddress: ZERO_ADDRESS,
      WETHAddress: '0x4200000000000000000000000000000000000006',
      routerAddress: {
        'uniswap': '0x2626664c2603336E57B271c5C0b26F421741e481'
      },
      defaultAddress: ZERO_ADDRESS
    }
  },
  {
    id: 'arb-v4-current',
    chainId: 42161,
    version: 'v4',
    description: 'Arbitrum (current)',
    canCreate: false,
    addresses: {
      factoryAddress: '0x9A6303f55FD013d58898994D563Cb0Bf60F4eC82',
      multicallAddress: '0xB8bAA4dE87feD17e45206eB7DB6619bb198222Ff',
      infoAddress: '0xfd6a2937355D7ab36BfC318894223853A1f6807D',
      hotKeyAddress: '0x374Ad0440Cd5c8E1A8412C156BeeEcE108EF4bB6',
      contractAddress: ZERO_ADDRESS,
      WETHAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      routerAddress: {
        'uniswap': '0x2626664c2603336E57B271c5C0b26F421741e481'
      },
      defaultAddress: ZERO_ADDRESS
    }
  },
  {
    id: 'bsc-v4-legacy',
    chainId: 56,
    version: 'v4',
    description: 'BSC Legacy V1',
    canCreate: false,
    addresses: {
      factoryAddress: '0x7CF14E96B1ED04a957Ef6e3867526D7334b7EcDA',
      multicallAddress: '0x6922c82379EC6b4F86061551B552B02C1063D8D5',
      infoAddress: '0x65671956EC253e22b97e5881a34D46756B3Dbb78',
      hotKeyAddress: '0x374Ad0440Cd5c8E1A8412C156BeeEcE108EF4bB6',
      contractAddress: ZERO_ADDRESS,
      WETHAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      routerAddress: {
        'uniswap': '0x10ED43C718714eb63d5aA57B78B54704E256024E'
      },
      defaultAddress: ZERO_ADDRESS
    }
  },
  {
    id: 'subtensor-v2-legacy',
    chainId: 964,
    version: 'v2',
    description: 'Subtensor EVM Legacy V2',
    canCreate: true,
    addresses: {
      factoryAddress: '0x4Ea82FC5df1AdA16997d87ab5041b9D808ce738d',
      multicallAddress: '0xf91ed41f9294e542b0df43ed6aa7ec40acf58e87',
      WETHAddress: '0x272b921417197905b5a2736cadadbd842586ac6b',
      routerAddress: {
        'hotkeyswap' : '0x067514bD489fa0E4cf3BF8eeCE4479362aeb2611'
      },
      contractAddress: ZERO_ADDRESS,
      defaultAddress: ZERO_ADDRESS
    }
  }
]
